module.exports = __webpack_public_path__ + "img/logo-app.c084882f.png";